module.exports = __webpack_public_path__ + "img/newsletter20.b92d17ad.jpeg";